import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ApiError } from '../api';

export interface SystemStatus {
  error?: ApiError;
  loading?: boolean;
  unavailableBackend?: boolean;
  status?: number | undefined | null;
}

const INITIAL_STATE: SystemStatus = {
  loading: false,
  error: {
    message: null,
    httpStatus: null,
  },
  unavailableBackend: false,
};

const systemSlice = createSlice({
  name: 'system',
  initialState: INITIAL_STATE,
  reducers: {
    onUpdateLoading: (state, action: PayloadAction<SystemStatus>) => ({
      ...state,
      loading: action.payload.loading,
    }),
    onError: (state, action: PayloadAction<SystemStatus>) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    onClearError: () => {
      return INITIAL_STATE;
    },
  },
});

export const { onUpdateLoading, onError, onClearError } = systemSlice.actions;

export default systemSlice.reducer;
